"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Footer.css");
var Footer = function (_a) {
    var feedbackButton = _a.feedbackButton, themeMode = _a.themeMode, currentTheme = _a.currentTheme;
    return (react_1.default.createElement("div", { className: "footer-root", "data-testid": "footer", style: {
            background: currentTheme.homePage.mainBackground,
            color: currentTheme.footer.textColor,
            marginLeft: '1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1vh',
            zIndex: 1000,
        } },
        react_1.default.createElement("span", { style: { fontSize: "1.5vh", marginBottom: "1.5vh" } },
            "\u00A9 ",
            new Date().getFullYear(),
            " Voicecare | All rights reserved"),
        feedbackButton));
};
exports.default = Footer;
